import React, { useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Sheet,
    ListItem,
    ListItemButton,
    ListItemContent
} from '@mui/joy';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router-dom';
import SearchCollege from '../../inputs/SearchCollege';

export default function CreatePDF() {
    const navigate = useNavigate();

    const storedCollege = useMemo(() => {
        try {
            const raw = localStorage.getItem('pdfSelectedCollege');
            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            console.error('Error parsing stored PDF college', error);
            return null;
        }
    }, []);

    const [selectedCollege, setSelectedCollege] = useState(storedCollege);
    const [searchResults, setSearchResults] = useState(storedCollege ? [storedCollege] : []);

    const navigateToGeneratePDF = (college) => {
        navigate("/generatepdf", {
            state: {
                visit: college,
                fromSearch: true // Add this flag
            }
        });
    };

    const handleCollegeSelect = (college) => {
        setSelectedCollege(college);
        if (college) {
            localStorage.setItem('pdfSelectedCollege', JSON.stringify(college));
            // Add to search results and navigate immediately
            setSearchResults([college]);
            navigateToGeneratePDF(college);
        } else {
            localStorage.removeItem('pdfSelectedCollege');
            setSearchResults([]);
        }
    };

    const handleCollegeClick = (event, college) => {
        if (event.defaultPrevented) return;
        event.preventDefault();
        navigateToGeneratePDF(college);
    };

    return (
        <Box sx={{ maxWidth: 600, margin: 'auto', mt: 4 }}>
            <Typography level="h4" component="h1" sx={{ mb: 2 }}>
                College Search
            </Typography>
            <Sheet variant="outlined" sx={{ p: 2, borderRadius: 'sm' }}>
                <SearchCollege
                    college={selectedCollege}
                    onCollegeChange={handleCollegeSelect}
                    label="Search College"
                />
            </Sheet>
            {searchResults.length > 0 && (
                <Sheet variant="outlined" sx={{ mt: 4, p: 2, borderRadius: 'sm' }}>
                    <Typography level="h6" component="h2" sx={{ mb: 2 }}>
                        Search Results
                    </Typography>
                    {searchResults.map((college) => (
                        <ListItem key={college.id}>
                            <ListItemButton onClick={(e) => handleCollegeClick(e, college)}>
                                <ListItemContent>
                                    <Typography level="body-md" sx={{ fontWeight: 'bold', color: "#eb7a24" }}>{college.college_name}</Typography>
                                    <Typography level="body-sm">Code: {college.college_code}</Typography>
                                    {college.college_address && <Typography level="body-sm">Address: {college.college_address}</Typography>}
                                    {college.univerisity_name && <Typography level="body-sm">University: {college.univerisity_name}</Typography>}
                                    {college.college_website && <Typography level="body-sm">Website: {college.college_website}</Typography>}
                                </ListItemContent>
                                <KeyboardArrowRightIcon />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </Sheet>
            )}
        </Box>
    );
}
